export enum iFrameMessageTypes {
  StatusPage = 'Application Completed',
}
